import {useMessage} from "/@/hooks/web/useMessage";
const { createHtmlMessage} = useMessage();
import asyncIcon from "/@/assets/images/async_icon.png";

export const  createAsyncMessage = (type) => {
  let typeMap = {
    import : '导入',
    export : '导出',
    process : '审核',
    repeat : '查重',
    report : '生成报告',
  }
  let content  = '正在'+typeMap[type]+', 可点击右侧<img src="'+ asyncIcon +'" alt="" style="width: 22px;display: inline-block;vertical-align: middle; margin: 0 8px;">查看'
  createHtmlMessage({
    type: 'success',
    duration: 3,
    content: content
  })
}

